import React from 'react'

function ExamModuleViewStudent(props) {
    return (
        <>
            {
                (props?.classValue && props?.assessmentSubjectValue) ?
                    (
                        <>
                            {(props?.routineData?.length > 0 && props?.filtereduniqueDates?.length > 0) ?
                                (
                                    <>
                                        {/* <table className='table table-bordered table-striped' border="1" style={{ borderCollapse: 'collapse', width: '100%' }}> */}
                                        <table className='table-bordered table-striped print-table' border="1" style={{ borderCollapse: 'collapse', width: '100%' }}>
                                            <thead className="tt-group-header">
                                                <tr>
                                                    {/* added minwidth style to evenly distribute width in table column /header */}
                                                    <th style={{ padding: '8px', textAlign: 'left', minWidth: "110px" }}>
                                                        <div className='d-flex align-items-center justify-content-center w-100'>
                                                            Date
                                                        </div>
                                                    </th>
                                                    <th style={{ padding: '8px', textAlign: 'left', minWidth: "110px" }}>
                                                        <div className='d-flex align-items-center justify-content-center w-100'>
                                                            Subjects
                                                        </div>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {props?.filtereduniqueDates?.map((date, index) => (
                                                    <tr key={index}>
                                                        <td style={{ padding: '8px', textAlign: 'center' }}>
                                                            <div className='mt-1 d-flex align-items-center justify-content-center'>
                                                                {date}
                                                            </div>
                                                        </td>
                                                        <td style={{ padding: '8px', textAlign: 'center' }}>
                                                            <div className='d-flex flex-column align-items-center w-100'>
                                                                {props?.filteredTable[date.split(' ')[0]]?.map((subjectData, index) => (
                                                                    <div key={index} className="p-1 d-flex flex-row align-items-center justify-content-center">
                                                                        <span>
                                                                            {subjectData}
                                                                        </span>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </>) :
                                (
                                    <>
                                        <p className='text-center mt-2'>
                                            The selected assessment is either not configured for the specified class, or there are no students available in the class.
                                        </p>
                                    </>)}

                        </>) :
                    (
                        <>
                            <p className='text-center mt-2'>
                                Select the above field to view the records.
                            </p>
                        </>)
            }
        </>
    )
}

export default ExamModuleViewStudent